import { render } from "./StockProfileTable.vue?vue&type=template&id=a9770626"
import script from "./StockProfileTable.vue?vue&type=script&lang=js"
export * from "./StockProfileTable.vue?vue&type=script&lang=js"

import "./StockProfileTable.vue?vue&type=style&index=0&id=a9770626&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__